import { wrap } from "comlink";
const worker = new Worker(new URL("~/server/worker.ts", import.meta.url));
const api = wrap(worker);
export default api;
